import Vue from "vue";
import { IonicVueRouter } from "@ionic/vue";
import auth from "@/store/modules/auth";

Vue.use(IonicVueRouter);

const router = new IonicVueRouter({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      meta: {
        requiresAuth: false
      },
      component: () => import("@/views/Login.vue")
    },
    {
      path: "/setup",
      name: "setup",
      meta: {
        requiresAuth: true
      },
      component: () => import("@/views/CreateProfile.vue")
    },
    {
      path: "/",
      name: "root",
      redirect: "/home",
      component: () => import("@/views/TabView.vue"),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: "/home",
          name: "home",
          components: { 
            home:  () => import("@/views/Home.vue")
          },
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/trip",
          name: "trip",
          components: { 
            trip: () => import("@/views/Trip.vue") 
          },
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/trip/create",
          name: "createTrip",
          components: {
            trip: () => import("@/views/CreateTrip.vue")
          },
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/trip/:id",
          name: "viewTrip",
          props: true,
          components: {
            trip: () => import("@/views/ViewTrip.vue")
          },
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/profile",
          name: "profile",
          components: {
            profile: () => import("@/views/Profile.vue")
          },
          meta: {
            requiresAuth: true
          }
        }
      ]
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  await auth.bindAuthentication();
  const requiresAuth = to.matched.some(page => page.meta.requiresAuth);
  console.log("Route to " + to );
  console.log('Requires auth? ' + requiresAuth);
  console.log('Is authenticated for route :'  + auth.isAuthenticated);
  if (requiresAuth && !auth.isAuthenticated) next("login");
  else if (!requiresAuth && auth.isAuthenticated) next("home");
  else next();
});

export default router;
